import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-alternative-transfer',
  templateUrl: './alternative-transfer.component.html',
  styleUrls: ['./alternative-transfer.component.sass'],
})
export class AlternativeTransferComponent {
  @Input() alternativeName: string;
  @Input() amount: number;
  @Input() percentage: number;
  @HostBinding('class.small')
  @Input()
  isSmall = false;
}
